import { MultipleAssetResponse } from "../../@types/Asset";
import { api } from "../api";

export default async function getMultiple(
  encodedIds: string
): Promise<MultipleAssetResponse | null> {
  try {
    const { data } = await api.get(`/assets/by-list?list=${encodedIds}`);

    return data;
  } catch (err) {
    console.log(err);

    return null;
  }
}
